import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FiInfo } from "react-icons/fi";
import {
  CountryField,
  FORMALITY_COUNTRIES,
  FormalityPage,
  TextField,
  fieldError,
} from "../../../components/formalities/FormalityParts";
import { showError } from "../../../components/options/OptionParts";
import { addToCart } from "../../../redux/actions/CartActions";
import { createTaxComplianceRequest } from "../../../redux/actions/FormalityActions";

const TAX_COMPLIANCE_PRICE = 5000;

// Tax compliance certificate: only the taxpayer number is needed
function TaxCompliance() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);

  const [country, setCountry] = useState(FORMALITY_COUNTRIES[0]);
  const [niu, setNiu] = useState("");
  const [touched, setTouched] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const niuError = fieldError(niu);

  const handleCreated = async ({ success, message }) => {
    if (!success) {
      setSubmitting(false);
      showError(Swal, message);
      return;
    }

    await dispatch(
      addToCart({ from: "taxCompliance", price: TAX_COMPLIANCE_PRICE }),
    );
    setSubmitting(false);
    // No document to provide for this formality
    navigate("/formality-payment");
  };

  const handleContinue = () => {
    setTouched(true);
    if (!country || niuError) return;

    setSubmitting(true);
    dispatch(
      createTaxComplianceRequest(
        user.token,
        { country, niu: niu.trim() },
        handleCreated,
      ),
    );
  };

  return (
    <FormalityPage
      from="taxCompliance"
      title="Attestation de conformité fiscale"
      lead="Il nous faut seulement votre numéro d'identifiant unique (NIU)."
      price={TAX_COMPLIANCE_PRICE}
      submitting={submitting}
      onContinue={handleContinue}
    >
      <CountryField value={country} onChange={setCountry} />

      <TextField
        id="tax-compliance-niu"
        label="Numéro d'identifiant unique (NIU)"
        placeholder="Ex. : P012345678901A"
        value={niu}
        onChange={setNiu}
        error={touched ? niuError : null}
      />

      <p className="flow-notice">
        <FiInfo aria-hidden="true" />
        <span>
          Si le contribuable n'est pas à jour de ses impôts, des frais
          supplémentaires peuvent être demandés pour régulariser sa situation.
        </span>
      </p>
    </FormalityPage>
  );
}

export default TaxCompliance;
